// Grid metadata
export const GRID_NAME_MAX_LENGTH = 64;
export const GRID_NUMBER_LOCALE = 'en-CH';

// Grid map
export const GRID_MAP_ZOOM_OFFSET = 8.25;
export const INITIAL_GRID_MAP_CENTER: [number, number] = [46.005978, 8.952455];
export const CADASTRAL_MIN_ZOOM = 22;
export const CADASTRAL_MAX_ZOOM = 28;
export const CADASTRAL_EDGE_CLICK_MAX_DISTANCE_PX = 4;
export const VISUALIZER_PREVIEW_RELOAD_EVENT = 'um:visualizer-preview-reload';

// Analysis areas
export const MAX_ALLOWED_GRID_AREA = 10000000;
export const MIN_ANALYSIS_AREA = 5;
export const MAX_ANALYSIS_AREAS = 10;
export const GRID_CONTAINMENT_TOLERANCE_AREA = 0.25;
export const GRID_CONTAINMENT_INNER_BUFFER_METERS = 0.05;

// Terrain height
export const ABSOLUTE_FLAT_TERRAIN_HEIGHT_MIN = 1;
export const ABSOLUTE_FLAT_TERRAIN_HEIGHT_MAX = 10000;
